import { Action, combineReducers } from 'redux';

import { recommendationsChannelReducer } from '../../recommendations/reducers/RecommendationsReducer';
import {
  isCloseWelcomeChannelAction,
  isGetServerWelcomeChannelInfoSucceeded,
  isUpdateShowWelcomeChannelAction
} from '../actions/HomeActions';
import { HomeState, WelcomeChannelState } from '../types/HomeTypes';
import { favoritesContentReducer, popularContentReducer, recentsContentReducer, sharedWithMeContentReducer } from './ChannelContentReducer';

const defaultWelcomeChannelState: WelcomeChannelState = {
  userDismissedWelcomeChannel: false,
};

export function welcomeChannelReducer(previousState: WelcomeChannelState = defaultWelcomeChannelState, action: Action): WelcomeChannelState {
  if (isGetServerWelcomeChannelInfoSucceeded(action)) {
    const updatedState = {...previousState, welcomeChannelInfo: action.welcomeChannelInfo};
    return updatedState;
  } else if (isCloseWelcomeChannelAction(action)) {
    const updatedState = {...previousState, userDismissedWelcomeChannel: true};
    return updatedState;
  } else if (isUpdateShowWelcomeChannelAction(action)) {
    const updatedState = { ...previousState, userDismissedWelcomeChannel: false};
    return updatedState;
  } else {
    return previousState;
  }
}

export const homeReducer: (previousState: HomeState, action: Action) => HomeState = combineReducers<HomeState>({
  favorites: favoritesContentReducer,
  recents: recentsContentReducer,
  popular: popularContentReducer,
  recommendations: recommendationsChannelReducer,
  sharedWithMe: sharedWithMeContentReducer,
  welcomeChannel: welcomeChannelReducer
});

